/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Invalid_SourceInputs */

const en_api_error_task_invalid_source = /** @type {(inputs: Api_Error_Task_Invalid_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A completed source activity for this case or client is required.`)
};

const pt_br2_api_error_task_invalid_source = /** @type {(inputs: Api_Error_Task_Invalid_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É necessária uma atividade de origem concluída para este caso ou cliente.`)
};

/**
* | output |
* | --- |
* | "A completed source activity for this case or client is required." |
*
* @param {Api_Error_Task_Invalid_SourceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_invalid_source = /** @type {((inputs?: Api_Error_Task_Invalid_SourceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Invalid_SourceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_invalid_source(inputs)
	return pt_br2_api_error_task_invalid_source(inputs)
});